import React, { Component } from 'react';

import cx from 'classnames';
import _memoize from 'lodash.memoize';
import memoizeOne from 'memoize-one';
import { ACCORDION, PANEL, TITLE, TITLE_WRAPPER } from '../styles/accordion';
import Icon from '../../Icon';
import Text from '../../Text';
import '../styles/_accordion.scss';































class Accordion extends Component {
  onAnimationEnd = memoizeOne((index) => () => {
    const { panelRefs } = this.state;

    panelRefs[index].removeEventListener('transitionend', this.onAnimationEnd(index));

    this.setState({ animating: false });
  });

  selectAccordion = _memoize((index) => () => {
    const { scrollHeights, panelRefs, selectedAccordionIndex } = this.state;
    const newHeights = [...scrollHeights];

    newHeights.splice(index, 0, panelRefs[index].scrollHeight);

    if (index !== selectedAccordionIndex) {
      panelRefs[index].addEventListener('transitionend', this.onAnimationEnd(index));
    }

    this.setState({ scrollHeights: newHeights, animating: true }, () => {
      // Waits for animating to be true and a max height to be applied before selecting
      // the accordion and triggering the transition
      setTimeout(() => {
        this.setState({
          selectedAccordionIndex: index === selectedAccordionIndex ? void 0 : index
        });
        this.getAccordionOpenIndex();
        panelRefs[index].addEventListener('transitionend', this.onAnimationEnd(index));
      });
    });
  });

  constructor(props) {
    super(props);

    this.state = {
      scrollHeights: [],
      panelRefs: [],
      animating: false,
      selectedAccordionIndex: props.initialOpenIndex,
      initialOpenAllAccordions: props.initialOpenAll || false
    };
  }

  componentDidMount() {
    this.getAccordionOpenIndex();
  }

  componentDidUpdate(prevProps) {
    const { initialOpenIndex } = this.props;

    if (prevProps.initialOpenIndex !== initialOpenIndex) {
      this.setSelectedAccordionIndex(initialOpenIndex);
    }
  }

  setSelectedAccordionIndex = (initialIndex) => {
    this.setState({ selectedAccordionIndex: initialIndex });
  };

  setChildRefs = _memoize((index) => (ref) => {
    if (!ref) {return;}

    this.setState(({ panelRefs, scrollHeights }) => {
      const newRefs = [...panelRefs];
      const newHeights = [...scrollHeights];

      newRefs.splice(index, 0, ref);
      newHeights.splice(index, 0, ref.scrollHeight);

      return { panelRefs: newRefs, scrollHeights: newHeights };
    });
  });

  getAccordionOpenIndex = () => {
    const { getOpenIndex } = this.props;
    const { selectedAccordionIndex } = this.state;

    if (!getOpenIndex) {return;}

    getOpenIndex(selectedAccordionIndex);
  };

  renderTitle = (title) => {
    const { label, prefix, prefixSize, subtitle: rawSubtitle, required, featuretooltip } = typeof title === 'string' ?
    { label: title, prefix: void 0, prefixSize: void 0, subtitle: null, required: false, featuretooltip: '' } :
    title;
    const { isV2NewDesign } = this.props;

    if (isV2NewDesign) {
      return (
        <div className="accordion-v2__title-wrapper--contianer">
          <div className="accordion-v2__title-wrapper--contianer__title">
            <Text
              {...{
                heading5: true,
                noMargin: true,
                prefixIcon: prefix || void 0,
                prefixSize: prefixSize || void 0,
                className: cx(TITLE, 'accordion__title'),
                children: label,
                required
              }}
              centered />

            <div className="title-tooltip">
              {featuretooltip}
            </div>
          </div>
          <hr />
          {rawSubtitle !== '' &&
          <Text
            noMargin
            caption
            centered
            className={cx('accordion__subtitle', 'accordion-v2__title-wrapper--contianer__subtitle')}>

            {rawSubtitle}
          </Text>}

        </div>);

    }

    const mainTitle =
    <Text
      {...{
        heading5: true,
        noMargin: true,
        prefixIcon: prefix || void 0,
        prefixSize: prefixSize || void 0,
        className: cx(TITLE, 'accordion__title'),
        children: label
      }} />;



    if (!rawSubtitle) {
      return mainTitle;
    }

    const subtitle = typeof rawSubtitle === 'string' ?

    <Text className="accordion__subtitle">
          {rawSubtitle}
        </Text> :
    rawSubtitle;
    return (
      <div>
        {mainTitle}
        {subtitle}
      </div>);

  };

  renderSingleAccordion = (child, index) => {
    const { titles, darkMode, shouldPreventSelection, isV2NewDesign, suffix } = this.props;
    const {
      selectedAccordionIndex,
      scrollHeights,
      animating,
      initialOpenAllAccordions
    } = this.state;
    const isCurrentAccordion = initialOpenAllAccordions ?
    selectedAccordionIndex !== index :
    selectedAccordionIndex === index;
    const maxHeight = isCurrentAccordion ? `${scrollHeights[index]}px` : '0';

    return (
      <div className={cx(ACCORDION, 'accordion', { 'accordion--dark-mode': darkMode })} key={index}>
        <div
          className={cx(TITLE_WRAPPER, 'accordion__title-wrapper', isV2NewDesign && 'accordion-v2__title-wrapper')}
          tabIndex={0}
          role="button"
          onClick={!shouldPreventSelection && this.selectAccordion(index)}
          onKeyPress={!shouldPreventSelection && this.selectAccordion(index)}>

          {this.renderTitle(Array.isArray(titles) ? titles[index] : titles)}
          {!shouldPreventSelection &&
          <div className={cx({ 'accordion--suffix': suffix })}>
              {suffix &&
            <div>
                  {typeof suffix === 'string' ? <Text label>{suffix}</Text> : suffix}
                </div>}

              <Icon
              color={darkMode ? 'white' : 'black'}
              size={15}
              name="chevrondown"
              className={cx(
                'accordion__title-wrapper__chevron',
                { 'accordion__title-wrapper__chevron__active': isCurrentAccordion }
              )} />

            </div>}

        </div>
        <div
          className={cx(
            PANEL(animating || !isCurrentAccordion ? maxHeight : 'inherit'),
            'accordion__panel'
          )}
          ref={this.setChildRefs(index)}>

          {child}
        </div>
      </div>);

  };

  render() {
    const { children, className } = this.props;

    return (
      <div className={className}>
        {
        Array.isArray(children) ?
        children.map(this.renderSingleAccordion) :
        this.renderSingleAccordion(children, 0)}

      </div>);

  }
}

export default Accordion;